import { SvgIcon, SvgIconProps } from "@mui/material";
import { ReactComponent as FouTrainingIconSvg } from "../../../assets/icons/gestione_finanziata.svg";

const IconFoundedTraining = (props: SvgIconProps) => (
  <SvgIcon
    component={FouTrainingIconSvg}
    inheritViewBox
    {...props}
    sx={{ ...props.sx, padding: "2px", marginRight: "8px" }}
  />
);

export default IconFoundedTraining;
